import {
    AssetDataService,
    AssetDataV2Service,
} from '@atbay/new-stance-aggregator-node-sdk'
import { createClient } from '@core/base/http-client'

export const AggregatorClient = createClient(AssetDataService)
export const AggregatorV2Client = createClient(AssetDataV2Service)
